import { useCallback } from "react";
import { useDragStore } from "@/stores/useDragStore";
import { createDragImage } from "./drag-image";
import { DND_MIME, type DragPayload } from "./payload";

/**
 * 任意の要素をドラッグ可能にする DOM props を返す。draggable な HTML 要素に展開する。
 * dragStart でグローバルなドラッグストアにペイロードを載せ、dragEnd で必ずクリアする。payload が null ならドラッグさせない。
 */
export function useDraggable(payload: DragPayload | null) {
	const beginDrag = useDragStore((s) => s.beginDrag);
	const endDrag = useDragStore((s) => s.endDrag);

	const onDragStart = useCallback(
		(e: React.DragEvent) => {
			if (payload === null) return;
			// ネストした要素では内側のソースを優先する。
			e.stopPropagation();
			beginDrag(payload);
			// dataTransfer はクロスウィンドウ／ネイティブのフォールバック。アプリ内ロジックはストアを読む。
			e.dataTransfer.setData(DND_MIME, JSON.stringify(payload));
			// 移動かコピーかはドロップ先が dropEffect で選ぶ。
			e.dataTransfer.effectAllowed = "copyMove";
			// ブラウザ既定の半透明スナップショットの代わりに、独自のドラッグ画像を表示する。
			const { element, offsetX, offsetY } = createDragImage(payload);
			e.dataTransfer.setDragImage(element, offsetX, offsetY);
		},
		[beginDrag, payload],
	);

	const onDragEnd = useCallback(() => endDrag(), [endDrag]);

	return { draggable: payload !== null, onDragStart, onDragEnd };
}
